// extracted by mini-css-extract-plugin
export default {"BaseCell":"number-renderer-module__BaseCell--gd1AC"};